import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import VendorMessageDto from '../../../core/dtos/vendor-message.dto';
import { environment } from '../../../../environments/environment';
import { lastValueFrom, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  constructor(private http: HttpClient) {}

  sendMessage(data: VendorMessageDto) {
    return this.http.post(
      `${environment.apiUrl}/static-page/contact/send-message/`,
      data
    );
  }

  sendMessageToBot(message: string): Promise<{
    response: string;
    bot_name: string;
  }> {
    const resp = this.http
      .post(`${environment.botApiUrl}/chat`, {
        message,
        language: 'es',
      })
      .pipe(take(1));

    return lastValueFrom(resp as any);
  }
}
